// src/components/contact/ContactInfoCard.jsx
import { MapPin, Phone, Mail, Globe } from "lucide-react";
import { motion } from "framer-motion";

const ContactInfoCard = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      className="mt-16 max-w-5xl mx-auto bg-gradient-to-br from-white via-blue-50 to-purple-50 shadow-xl rounded-2xl p-8 text-center space-y-4"
    >
      <h3 className="text-2xl font-heading font-bold text-primary">
        Get in Touch with Our Team
      </h3>
      <p className="text-gray-700 text-lg font-medium">
        <span className="block text-secondary">Suresh Pawar</span>
        Chief Impact Catalyst, Impact Together Consultancy Services
      </p>

      <div className="flex flex-col sm:flex-row justify-center gap-6 mt-4 text-left">
        <div className="flex items-center gap-3 text-gray-800">
          <MapPin className="text-primary" />
          <span>Pune, Maharashtra</span>
        </div>
        <div className="flex items-center gap-3 text-gray-800">
          <Phone className="text-primary" />
          <span>+91 8788971006</span>
        </div>
        <div className="flex items-center gap-3 text-gray-800">
          <Mail className="text-primary" />
          <span>suresh@impacttogether.in</span>
        </div>
        <div className="flex items-center gap-3 text-gray-800">
          <Globe className="text-primary" />
          <a
            href="https://www.impacttogether.in"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline"
          >
            www.impacttogether.in
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactInfoCard;
